import type { ApolloError } from '@apollo/client';
import type { Provider } from '@openx/types/provider';
import type { FormSegment, LookalikeSegmentDefinition } from '../../../types';
import type { SegmentFilters } from '../components/drawer/components/SegmentsList/types';
import type { DataSourceOptions } from '../components/drawer/components/types';

export type RangeFilter = string[];

export type UseSegmentsOptions = {
  definitions?: LookalikeSegmentDefinition[];
  segments?: FormSegment[];
  accountId?: string;
  providerId?: string;
  searchPhrase?: string;
  dataSourceFilters?: DataSourceOptions;
  filters: SegmentFilters;
  marketContext?: {
    regionCode: string | null;
    countries: string[];
  };
  linkedProviders: Provider[];
  limit?: number;
};

export type UseSegments<T> = (props: UseSegmentsOptions) => UseSegmentsResponse<T>;

export type UseSegmentsResponse<T> = {
  loading: boolean;
  error?: ApolloError;
  segments: T[];
  totalCount: number;
  refetch: () => void;
};

export const SegmentCategory = {
  DIRECT: 'direct',
  PREDEFINED: 'predefined',
  LOOKALIKE: 'lookalike',
} as const;
